export const salePromotionDetail = {
    salePromotionParam: '',
    showType: '2',
    styleType: '1',
    saleCountTimeInterval: {},
    showSaleTime: false,
    showSaleDlMore: false,
    saleReSalePriceHtml: '',
};
